<form>
  <h1 mat-dialog-title>{{(service.isUpdateUserAccount? 'Accounts.addUserAccount.headerEdit':
  'Accounts.addUserAccount.headerNew') | translate}}</h1>
  <div class="container">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field class="col-12">
            <mat-label>{{'Accounts.addUserAccount.lblUsername' | translate}}</mat-label>
            <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblUsername' | translate}}"
              [(ngModel)]="userAccount.username" [ngModelOptions]="{standalone: true}" required maxlength="75"/>
            </mat-form-field>
            <mat-form-field class="col-12">
              <mat-label>{{'Accounts.addUserAccount.lblPassword' | translate}}</mat-label>
              <input [type]="!isPasswordVisible ? 'password' : 'text'" matInput
                placeholder="{{'Accounts.addUserAccount.lblPassword' | translate}}" [(ngModel)]="userAccount.password"
                [ngModelOptions]="{standalone: true}" />
                <mat-icon class="clickable" matSuffix (click)="isPasswordVisible = !isPasswordVisible">{{!isPasswordVisible?
                'visibility_off' : 'visibility'}}</mat-icon>
              </mat-form-field>
              <mat-form-field class="col-12">
                <mat-label>{{'Accounts.addUserAccount.lblEmail' | translate}}</mat-label>
                <input type="email" matInput placeholder="{{'Accounts.addUserAccount.lblEmail' | translate}}"
                  [(ngModel)]="userAccount.email" [ngModelOptions]="{standalone: true}" required maxlength="75" />
                </mat-form-field>
                <mat-form-field class="col-12">
                  <mat-label>{{'Accounts.addUserAccount.lblRole' | translate}}</mat-label>
                  <mat-select multiple [(ngModel)]="userAccount.roleIds" [ngModelOptions]="{standalone: true}">
                    @for (role of roles; track role) {
                      <mat-option [value]="role.id">{{role.value}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="col-12">
                  <mat-label>{{'Accounts.addUserAccount.lblGenMarkets' | translate}}</mat-label>
                  <mat-select multiple [(ngModel)]="userAccount.generalMarketIds" [ngModelOptions]="{standalone: true}">
                    @for (market of markets; track market) {
                      <mat-option [value]="market.id">{{market.value}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <!-- <div class="row">
                <div class="col-6">
                  <mat-slide-toggle color="primary" [(ngModel)]="userAccount.manager" [ngModelOptions]="{standalone: true}"
                  (change)="OnAbilityChange(0)">{{'Accounts.addUserAccount.tglManager' | translate}}</mat-slide-toggle>
                </div>
                <div class="col-6">
                  <mat-slide-toggle color="primary" [(ngModel)]="userAccount.readonly" [ngModelOptions]="{standalone: true}"
                  (change)="OnAbilityChange(1)">{{'Accounts.addUserAccount.tglReadOnly' | translate}}</mat-slide-toggle>
                </div>
              </div> -->
            </div>
            <div class="col-lg-6 col-md-12">
              <mat-form-field class="col-12">
                <mat-label>{{'Accounts.addUserAccount.lblFirstName' | translate}}</mat-label>
                <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblFirstName' | translate}}"
                  [(ngModel)]="userAccount.firstName" [ngModelOptions]="{standalone: true}" required maxlength="25"/>
                </mat-form-field>
                <mat-form-field class="col-12">
                  <mat-label>{{'Accounts.addUserAccount.lblLastName' | translate}}</mat-label>
                  <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblLastName' | translate}}"
                    [(ngModel)]="userAccount.lastName" [ngModelOptions]="{standalone: true}" required maxlength="25"/>
                  </mat-form-field>
                  <mat-form-field class="col-12">
                    <mat-label>{{'Accounts.addUserAccount.lblPhone' | translate}}</mat-label>
                    <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblPhone' | translate}}"
                      (keyup)="ValidateNumber(0)" [(ngModel)]="userAccount.phone" [ngModelOptions]="{standalone: true}"
                      required />
                    </mat-form-field>
                    <mat-form-field class="col-12">
                      <mat-label>{{'Accounts.addUserAccount.lblMobile' | translate}}</mat-label>
                      <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblMobile' | translate}}"
                        (keyup)="ValidateNumber(1)" [(ngModel)]="userAccount.mobile" [ngModelOptions]="{standalone: true}" />
                      </mat-form-field>
                      <div class="row" style="padding: 0 15px 0 15px;">
                        <div class="col-12">
                          <mat-checkbox color="primary" [(ngModel)]="userAccount.enabled" [ngModelOptions]="{standalone: true}">
                          {{'Accounts.ckbxEnabled' | translate}}</mat-checkbox>
                        </div>
                      </div>
                      <div class="row"  style="padding: 0 15px 0 15px;">
                        <div class="col-6">
                          <mat-checkbox color="primary" [(ngModel)]="userAccount.twoFactor" [ngModelOptions]="{standalone: true}">
                          {{'Accounts.addUserAccount.ckbxTwoFactor' | translate}}</mat-checkbox>
                        </div>
                        <div class="col-6">
                          <!-- <mat-checkbox color="primary" [(ngModel)]="userAccount.challenge" [disabled]="true" [ngModelOptions]="{standalone: true}">
                        {{'Accounts.addUserAccount.ckbxChallenge' | translate}}</mat-checkbox> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <mat-form-field class="col-12">
                      <mat-label>{{'Accounts.addUserAccount.lblChallengeQu' | translate}}</mat-label>
                      <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblChallengeQu' | translate}}"
                        [(ngModel)]="userAccount.challengeQuestion" [ngModelOptions]="{standalone: true}"/>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <mat-form-field class="col-12">
                        <mat-label>{{'Accounts.addUserAccount.lblChallengeAnswer' | translate}}</mat-label>
                        <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblChallengeAnswer' | translate}}"
                          [(ngModel)]="userAccount.challengeAnswer" [ngModelOptions]="{standalone: true}"/>
                        </mat-form-field>
                      </div>
                    </div>
                    <div mat-dialog-actions class="mb-1">
                      <button mat-raised-button color="primary" (click)="OnSaveAccount()">{{'btnOk' | translate}}</button>&nbsp;
                      @if (service.currentUser && (service.currentUser.userRole === adminRoleName || (service.currentUser.userRole === operatorRoleName && userAccount.roleName !== operatorRoleName)) && forceHideLoginAs == false) {
                        <button mat-raised-button color="secondary" (click)="OnLoginAs()" [disabled]="isAccountEnabledOriginally == false || userAccount.enabled == false">{{'Accounts.addUserAccount.btnLogin' | translate}}</button>
                        }&nbsp;
                        <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
                      </div>
                    </div>
                  </div>
                </form>